export default "__VITE_ASSET__BuPYw5pX__"